import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const accordionListDefaultVariants = {}
const accordionListCompoundVariants = []

const accordionListSlotNames = [
  [
    "root",
    "accordionList__root"
  ],
  [
    "summary",
    "accordionList__summary"
  ],
  [
    "listItem",
    "accordionList__listItem"
  ],
  [
    "startIcon",
    "accordionList__startIcon"
  ],
  [
    "endIcon",
    "accordionList__endIcon"
  ],
  [
    "root",
    "accordionList__root"
  ],
  [
    "summary",
    "accordionList__summary"
  ],
  [
    "listItem",
    "accordionList__listItem"
  ],
  [
    "startIcon",
    "accordionList__startIcon"
  ],
  [
    "endIcon",
    "accordionList__endIcon"
  ]
]
const accordionListSlotFns = /* @__PURE__ */ accordionListSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, accordionListDefaultVariants, getSlotCompoundVariant(accordionListCompoundVariants, slotName))])

const accordionListFn = memo((props = {}) => {
  return Object.fromEntries(accordionListSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const accordionListVariantKeys = [
  "disabled",
  "dense",
  "selected",
  "expanded"
]
const getVariantProps = (variants) => ({ ...accordionListDefaultVariants, ...compact(variants) })

export const accordionList = /* @__PURE__ */ Object.assign(accordionListFn, {
  __recipe__: false,
  __name__: 'accordionList',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: accordionListVariantKeys,
  variantMap: {
  "disabled": [
    "true"
  ],
  "dense": [
    "true"
  ],
  "selected": [
    "true"
  ],
  "expanded": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, accordionListVariantKeys)
  },
  getVariantProps
})